module.exports = __webpack_public_path__ + "img/1016.3d92944f.png";